import { useEffect, useState } from "react";

const COOKIE_KEY = "cg-cookies";
const SHOW_DELAY = 2200;

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    if (window.localStorage.getItem(COOKIE_KEY)) return undefined;
    const t = setTimeout(() => setShow(true), SHOW_DELAY);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  const accept = () => {
    window.localStorage.setItem(COOKIE_KEY, "accepted");
    setShow(false);
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[90] bg-[#0A1628] border-t-[3px] border-[#E8721C]">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-5 flex flex-col md:flex-row items-center gap-5">
        <p className="text-white text-[14px] leading-6 flex-1">
          <span className="font-bold text-[#E8721C] tracking-wider">POPIA NOTICE · </span>
          Cassie Gee Investments uses cookies to improve your experience. By continuing you agree to our <a href="#" className="underline hover:text-[#E8721C]">Privacy Policy</a>.
        </p>
        <div className="flex gap-3">
          <button onClick={accept} className="btn-orange" data-testid="cookie-accept">Accept</button>
          <a href="#" className="btn-outline-white" data-testid="cookie-learn">Learn More</a>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
